<template>
      <a href="#" class="nav-link btn-buy" :class="[extraClass, {'disabled': isAlreadyAdded}]" @click.prevent="$emit('click')" >
        <span class="label" :class="{'invisible': loading}" v-if="!isAlreadyAdded">{{ label }} {{price}}</span>
        <span v-else>{{ $t('pages.checkins_detail.package_banner_btn_added') }}</span>
        <b-spinner label="Loading..." class="spin" v-if="loading" />
      </a>
</template>

<script>
export default {
  name: "ButtonPackage",
  props: {
    extraClass: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: false
    },
    isAlreadyAdded: {
      type: Boolean,
      default: false,
      required: false
    }

  }
}
</script>

<style scoped lang="scss">
.spin {
  width: 1.3em;
  height: 1.3em;
  border-width: 0.2em;
  position: absolute;
  top: 14px;
  left: 14px;
  right: 14px;
  z-index: 10;
  margin: 0 auto;
}
</style>